const BIG = [
  {
    img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20two%20anonymous%20silhouettes%20standing%20apart%20back%20to%20back%20under%20harsh%20red%20stage%20spotlight%20with%20light%20haze%20and%20camera%20flash%2C%20deep%20crimson%20and%20warm%20amber%20tones%20against%20dark%20background%2C%20dramatic%20moody%20documentary%20style%2C%20high%20contrast%20film%20grain&width=1200&height=760&seq=recap-1-2026&orientation=landscape",
    badge: "恋情 · 盘点 01",
    title: "顶流恋情曝光，公关如何一步步「炸掉热搜」",
    text: "从同款照片被扒，到工作室声明删博，再到粉丝后援会集体静音——复盘一件恋情瓜被引爆又压下的完整链路。",
    stat: "阅读 203.4w",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20dark%20boardroom%20conference%20table%20with%20scattered%20documents%20and%20a%20single%20warm%20desk%20lamp%20glow%2C%20empty%20chairs%20facing%20away%2C%20moody%20amber%20and%20deep%20red%20lighting%2C%20corporate%20scandal%20mystery%20atmosphere%2C%20cinematic%20documentary%20style%2C%20film%20grain&width=1200&height=760&seq=recap-2-2026&orientation=landscape",
    badge: "商界 · 盘点 02",
    title: "新锐品牌「换帅」背后，内部信到底说了啥",
    text: "创始人退位、加盟商讨说法、直播间销量跳水——本月最出圈的一场商业闹剧，按时间线拆给你看。",
    stat: "阅读 120.6w",
  },
  {
    img: "https://readdy.ai/api/search-image?query=backstage%20variety%20show%20photo%20of%20empty%20studio%20with%20bright%20warm%20ring%20lights%20and%20cameras%20facing%20empty%20stage%2C%20dark%20background%20with%20amber%20and%20crimson%20glimmer%2C%20unscripted%20drama%20moody%20atmosphere%2C%20cinematic%20editorial%20documentary%20photography&width=1200&height=760&seq=recap-3-2026&orientation=landscape",
    badge: "综艺 · 盘点 03",
    title: "一档国民综艺的「剪辑事故」全复盘",
    text: "恶意剪辑片段流出后，嘉宾、制片、平台三方各执一词。我们把正片与流出素材的时间点逐一对照，还原真相死角。",
    stat: "阅读 66.5w",
  },
];

export default function Recap() {
  return (
    <section id="recap" className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-7">
          <div>
            <p className="flex items-center gap-2 text-[13px] font-semibold text-accent-700 tracking-wide">
              <span className="w-1.5 h-3 rounded-sm bg-accent-500" />
              RECAP · 精选大图
            </p>
            <h2 className="mt-2 font-heading text-[28px] md:text-[36px] font-black text-foreground-950">
              近期盘点<span className="text-accent-500"> · </span>大图慢慢看
            </h2>
            <p className="mt-2 text-[14px] text-foreground-500 max-w-[560px]">
              本周最值得回看的三件大事，图文并重整理。同一件事，把背景、发酵与结局放在一张大图里讲清楚。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-800 px-4 py-1.5 text-[13px] font-semibold whitespace-nowrap">
            <i className="ri-edit-2-fill w-4 h-4 flex items-center justify-center" /> 编辑复盘 · 非搬运
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {BIG.map((b) => (
            <a
              key={b.badge}
              href="#timeline"
              className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-accent-300 hover:-translate-y-1 transition-all"
            >
              <div className="relative w-full h-[190px] md:h-[210px] overflow-hidden bg-background-100">
                <img
                  src={b.img}
                  alt={b.title}
                  title={`${b.title} - 近期盘点最新黑料`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute left-3 top-3 rounded-md bg-black/50 text-background-50 backdrop-blur px-2.5 py-1 text-[12px] font-semibold">
                  {b.badge}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-[16px] md:text-[17px] leading-snug font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {b.title}
                </h3>
                <p className="mt-2 text-[13.5px] leading-relaxed text-foreground-500 line-clamp-2">{b.text}</p>
                <div className="mt-3 flex items-center text-[12.5px] text-foreground-400">
                  <i className="ri-eye-line w-4 h-4 flex items-center justify-center mr-1" />
                  {b.stat}
                  <span className="ml-auto inline-flex items-center gap-1 font-medium text-accent-600 group-hover:gap-2 transition-all">
                    看完整复盘 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}